import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { ProjectIdParam, SshKeyInfo, Uuid } from "@/types"

type RegisterKeyRequestParams = {
  key: string
  name: string
}

// Define a service using a base URL and expected endpoints
export const sshKeysApi = createApi({
  reducerPath: "ssh-keys",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}ssh-keys`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    // list the type of supported protocols
    sshKeysGet: build.query<SshKeyInfo[], ProjectIdParam>({
      query: ({ project_id }) => ({
        url: project_id,
      }),
    }),
    sshKeysPost: build.mutation<
      SshKeyInfo,
      ProjectIdParam & RegisterKeyRequestParams
    >({
      query: (body) => ({
        url: body.project_id,
        method: "POST",
        body,
      }),
    }),
    sshKeysDelete: build.mutation<void, ProjectIdParam & { key_id: Uuid }>({
      query: ({ project_id, key_id }) => ({
        method: "DELETE",
        url: `${project_id}/${key_id}`,
      }),
    }),
  }),
})

export const {
  useSshKeysGetQuery,
  useSshKeysPostMutation,
  useSshKeysDeleteMutation,
} = sshKeysApi
